var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlatform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_62_1",
    "data-name": "Component 62 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.002,
    height: 21.999,
    viewBox: "0 0 22.002 21.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_82",
    "data-name": "Union 82",
    d: "M8864,7967a1,1,0,1,1,0-2h14a1,1,0,1,1,0,2Zm-3-4a1,1,0,1,1,0-2h20a1,1,0,1,1,0,2Zm10-7.131-4.327,3.13,1.5-5.292-4.168-3.359,5.249-.143,1.75-5.2,1.75,5.2,5.249.143-4.166,3.359,1.493,5.292Z",
    transform: "translate(-8859.999 -7945.001)",
    fill: "#5f5f5f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatform);
export default __webpack_public_path__ + "static/media/platform.94b22070c2e82e9c199ada5ce0d5cb80.svg";
export { ForwardRef as ReactComponent };